import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { checkAllProducts, clearAllProducts, deleteProducts, clearProductsError } from "../../../store/actions/admin/products";
import { EventsState } from "../../../store/types";
import ModalComponent from "../../general-ui/modal/modal";

interface DeletingOptionsProps {
	checkedSetSize: number;
	idList: number[]
}

const DeletingOptions: React.FC<DeletingOptionsProps> = ({ checkedSetSize, idList }) => {
	const {
		ProductsReducer: {
			checkedSet,
			productsError
		},
		AuthReducer: {
			token,
			user
		}
	} = useSelector((state: EventsState) => state);
	const [isDeleting, setIsDeleting] = useState(false);
	const dispatch = useDispatch();

	const handleCancel = () => dispatch(clearAllProducts());
	const handleSelectAll = () => dispatch(checkAllProducts(idList));
	const openDeleteModal = () => setIsDeleting(true);
	const closeDeleteModal = () => setIsDeleting(false);
	const handleDelete = () => {
		dispatch(deleteProducts(Array.from(checkedSet), token!, user!.active_channel));
		closeDeleteModal();
	};
	const closeWarningModal = () => dispatch(clearProductsError());

	const deleteWarning = `Are you sure you want to delete ${checkedSetSize === 1 ? "this" : "these"} product${checkedSetSize > 1 ? "s" : ""}?`;

	return (
		<div className="content-editing-options">
			<button className="editing-button" onClick={handleCancel}>Cancel</button>
			<button className="editing-button" onClick={handleSelectAll}>Select All</button>
			<button className="editing-button" onClick={openDeleteModal}>Delete</button>
			<ModalComponent
				title=""
				open={isDeleting}
				onRequestClose={closeDeleteModal}
				closeable={false}
				cancellable
				footer={
					<div className="delete-modal-buttons">
						<button onClick={closeDeleteModal}>Cancel</button>
						<button onClick={handleDelete} className="primary">Delete</button>
					</div>
				}
			>
				<p>{deleteWarning}</p>
			</ModalComponent>
			<ModalComponent
				title="Could not delete"
				open={!!productsError}
				onRequestClose={closeWarningModal}
				closeable
				cancellable
			>
				{/* <p>TODO: change to warning modal</p> */}
				<p>The following product(s) must be removed from all event homepages and sessions before being deleted: </p><em>{productsError}</em>
			</ModalComponent>
		</div>
	);
};

export default DeletingOptions;